<template>
  <canvas ref="chart"></canvas>
</template>

<script>
import { Chart } from "chart.js";

export default {
  name: "ChurnLineChart",
  props: {
    chartData: {
      type: Object,
      default: () => ({ labels: [], churnPercent: [], activeBase: [], newSubscriptions: [], cancellations: [], netGrowth: [] }),
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    renderChart() {
      if (!this.chartData || !this.chartData.labels || !this.chartData.churnPercent) return;

      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.chart.getContext("2d");
      const data = this.chartData;

      const datalabelsPlugin = {
        id: 'churnDatalabels',
        afterDatasetsDraw(chart) {
          const { ctx } = chart;
          chart.data.datasets.forEach((dataset, datasetIndex) => {
            const meta = chart.getDatasetMeta(datasetIndex);
            const isLine = dataset.type === 'line' || (!dataset.type && chart.config.type === 'line');
            meta.data.forEach((point, index) => {
              const value = dataset.data[index];
              if (value === 0 || value === null || value === undefined) return;
              ctx.save();
              if (isLine) {
                ctx.fillStyle = dataset.borderColor || '#e76f51';
                ctx.font = 'bold 10px sans-serif';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';
                ctx.fillText(value.toFixed(1) + '%', point.x, point.y - 8);
              } else {
                ctx.fillStyle = '#333';
                ctx.font = '9px sans-serif';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';
                ctx.fillText(value, point.x, point.y - 3);
              }
              ctx.restore();
            });
          });
        },
      };

      const legendMarginPlugin = {
        id: 'legendMargin',
        beforeInit(chart) {
          const originalFit = chart.legend.fit;
          chart.legend.fit = function fit() {
            originalFit.bind(chart.legend)();
            this.height += 20;
          };
        },
      };

      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: data.labels,
          datasets: [
            {
              label: "Base ativa",
              type: "bar",
              data: data.activeBase,
              backgroundColor: "#2e466480",
              barPercentage: 0.7,
              categoryPercentage: 0.8,
              yAxisID: "y",
              order: 3,
            },
            {
              label: "Novas assinaturas",
              type: "bar",
              data: data.newSubscriptions,
              backgroundColor: "#4a7c5980",
              barPercentage: 0.7,
              categoryPercentage: 0.8,
              yAxisID: "y",
              order: 2,
            },
            {
              label: "Cancelamentos",
              type: "bar",
              data: data.cancellations,
              backgroundColor: "#e76f5180",
              barPercentage: 0.7,
              categoryPercentage: 0.8,
              yAxisID: "y",
              order: 1,
            },
            {
              label: "Churn %",
              type: "line",
              data: data.churnPercent,
              borderColor: "#e76f51",
              backgroundColor: "#e76f5133",
              tension: 0.3,
              fill: false,
              pointRadius: 4,
              pointHoverRadius: 6,
              borderWidth: 2,
              yAxisID: "y1",
              order: 0,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
            },
          },
          interaction: {
            mode: "index",
            intersect: false,
          },
          plugins: {
            legend: {
              display: true,
              position: "top",
            },
            tooltip: {
              callbacks: {
                afterBody: (items) => {
                  const index = items[0].dataIndex;
                  return `Crescimento líquido: ${data.netGrowth[index]}`;
                },
              },
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              type: "linear",
              display: true,
              position: "left",
              beginAtZero: true,
              title: {
                display: true,
                text: "Quantidade",
              },
            },
            y1: {
              type: "linear",
              display: true,
              position: "right",
              beginAtZero: true,
              title: {
                display: true,
                text: "Churn %",
              },
              grid: {
                drawOnChartArea: false,
              },
              ticks: {
                callback: (value) => value + "%",
              },
            },
          },
        },
        plugins: [datalabelsPlugin, legendMarginPlugin],
      });
    },
  },
};
</script>
